import { useMutation } from '@tanstack/react-query';
import { useAuthenticatedFetch } from '../../../hooks/useAuth';

export function useFeatureInterestRequest() {
  const authenticatedFetch = useAuthenticatedFetch();
  return useMutation({
    mutationFn: async ({ interestId, contactEmail }: { interestId: string; contactEmail?: string }) => {
      const response = await authenticatedFetch('/api/sales/feature-interests', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ interestId, contactEmail }),
      });
      const body = await response.json().catch(() => ({})) as { error?: string };
      if (!response.ok) throw new Error(body.error ?? 'We could not send your request. Please try again.');
    },
  });
}
